<tmo-product-carousel
  (change)="moveToRoute($event)"
  [maxItems]="20"
  [deviceSectionAEMContent]="pdpStaticContent"
  [itemsToDisplay]="3"
  [useRouteParam]="true"
></tmo-product-carousel>
